export enum AdditionalModalDismissReasons {
    X_CLICK = -1,
    CANCEL_CLICK = -2,
    BACKDROP_CLICK = -3
}
